import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    title: 'Aena Partners',
    loadComponent: () => import('./pages/home/home').then(m => m.Home),
  },
  {
    path: 'login',
    title: 'Login — Aena Partners',
    loadComponent: () => import('./pages/login/login').then(m => m.Login),
  },
  {
    path: 'sso',
    title: 'SSO — Aena Partners',
    loadComponent: () => import('./pages/sso/sso').then(m => m.Sso),
  },
  {
    path: 'register-organization',
    title: 'Register Organization — Aena Partners',
    loadComponent: () => import('./pages/register-organization/register-organization').then(m => m.RegisterOrganization),
  },
  {
    path: 'reset-password',
    title: 'Reset Password — Aena Partners',
    loadComponent: () => import('./pages/reset-password/reset-password').then(m => m.ResetPassword),
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./pages/content/content').then(m => m.Content),
    data: { page: 'about' },
  },
  {
    path: 'terms',
    loadComponent: () =>
      import('./pages/content/content').then(m => m.Content),
    data: { page: 'terms' },
  },
  {
    path: 'privacy',
    loadComponent: () =>
      import('./pages/content/content').then(m => m.Content),
    data: { page: 'privacy' },
  }, {
    path: '**',
    redirectTo: '',
  },
];

